import React from 'react';
export function DashboardSettings () {
  return (
    <>
      <div>
        <img src="" alt="" />
        <h1>Dashboard settings</h1>
        <p>lorem ipsum</p>
        <img
          src="https://lqagroup.com/wp-content/uploads/2023/12/myLQA_HP.png"
          alt=""
        />
      </div>
    </>
  );
}
